export const selectCompanyListState = (state) => state.companyList;
